import { render, staticRenderFns } from "./FormDocNumber.vue?vue&type=template&id=9ca40514&scoped=true"
import script from "./FormDocNumber.vue?vue&type=script&lang=js"
export * from "./FormDocNumber.vue?vue&type=script&lang=js"
import style0 from "./FormDocNumber.vue?vue&type=style&index=0&id=9ca40514&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca40514",
  null
  
)

export default component.exports